import React from 'react'
import PropTypes from 'prop-types'

const MicExternalOn = ({ color }) => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.00445 3.24354C0.877985 3.09794 0.780685 2.93764 0.712551 2.76264C0.644418 2.58764 0.610352 2.40284 0.610352 2.20824C0.610352 1.75138 0.765985 1.36754 1.07725 1.05674C1.38805 0.745477 1.76722 0.589844 2.21475 0.589844C2.66182 0.589844 3.04332 0.745477 3.35925 1.05674C3.67518 1.36754 3.83315 1.75138 3.83315 2.20824C3.83315 2.40284 3.79932 2.58764 3.73165 2.76264C3.66352 2.93764 3.56132 3.09794 3.42505 3.24354H1.00445ZM3.89195 11.4104C3.29882 11.4104 2.79318 11.199 2.37505 10.7762C1.95692 10.3534 1.74785 9.84548 1.74785 9.25234H1.50005C1.43192 9.25234 1.36868 9.22318 1.31035 9.16484C1.25202 9.10651 1.21795 9.04328 1.20815 8.97514L0.741952 4.45454C0.722352 4.27954 0.765985 4.13371 0.872852 4.01704C0.979718 3.90038 1.11598 3.84204 1.28165 3.84204H3.13315C3.29882 3.84204 3.43508 3.90038 3.54195 4.01704C3.64882 4.13371 3.69245 4.27954 3.67285 4.45454L3.23535 8.97514C3.22555 9.04328 3.19148 9.10651 3.13315 9.16484C3.07482 9.22318 3.01158 9.25234 2.94345 9.25234H2.68165C2.68165 9.58274 2.80065 9.86951 3.03865 10.1126C3.27665 10.3558 3.56108 10.4773 3.89195 10.4773C4.22235 10.4773 4.50655 10.3558 4.74455 10.1126C4.98302 9.86951 5.10225 9.58274 5.10225 9.25234V2.74794C5.10225 2.15481 5.31132 1.64684 5.72945 1.22404C6.14758 0.801244 6.65298 0.589844 7.24565 0.589844C7.83878 0.589844 8.34442 0.801244 8.76255 1.22404C9.18069 1.64684 9.38975 2.15481 9.38975 2.74794V10.9435C9.38975 11.07 9.34355 11.1794 9.25115 11.2718C9.15875 11.3642 9.04932 11.4104 8.92285 11.4104C8.80618 11.4104 8.69932 11.3642 8.60225 11.2718C8.50518 11.1794 8.45665 11.07 8.45665 10.9435V2.74794C8.45665 2.41754 8.33742 2.13078 8.09895 1.88764C7.86095 1.64451 7.57652 1.52294 7.24565 1.52294C6.91525 1.52294 6.63105 1.64451 6.39305 1.88764C6.15458 2.13078 6.03535 2.41754 6.03535 2.74794V9.25234C6.03535 9.84548 5.82628 10.3534 5.40815 10.7762C4.99048 11.199 4.48508 11.4104 3.89195 11.4104ZM2.06845 8.37734H2.34565L2.69565 4.77514H1.71845L2.06845 8.37734Z"
        fill={color}
      />
    </svg>
  )
}

MicExternalOn.propTypes = {
  color: PropTypes.string,
}

MicExternalOn.defaultProps = {
  color: 'red',
}

export default MicExternalOn
